import { combineReducers } from 'redux';
import {
  MODAL_Flag_SUCCESS
} from "../action-types/userInfo";

const modalFlag = (state = {}, action) => {
  if (action.type === MODAL_Flag_SUCCESS) {
    return { ...state, ...action.data }
  }
  return state
}

export default combineReducers({
  modalFlag
})